export default "__VITE_ASSET__BycM6jzW__"